export const quoteStatus = {
  draft: "draft",
  sent: "sent",
  pending: "pending",
  accepted: "accepted",
  declined: "declined",
  grouped: "grouped",
  negotiated: "negotiated",
  expired: "expired",
};
